module.exports = __webpack_public_path__ + "img/nav-header-mobile-eternity@2x.5e4e4cc.jpg";